    <template>
        <div class="pa-4 text-center">
        <v-dialog
            v-model="editDialog"
            max-width="600"
        >
        <form action="" @submit.prevent="modifier()">
        <v-card
            title="modifier un article"
            >
            
                <v-card-text>
                <v-row dense>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-combobox
                            clearable
                            label="marques"
                            :items="itemsmarques"
                            v-model="props.itemtoEdit.marque"
                            variant="outlined"
                            :rules="rules(props.itemtoEdit.marque)"
                        ></v-combobox>
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-combobox
                            clearable
                            label="thème"
                            :items="itemsThemes"
                            v-model="props.itemtoEdit.theme"
                            variant="outlined"
                            :rules="rules(props.itemtoEdit.theme)"
                        ></v-combobox>
                    </v-col>
    
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-combobox
                            clearable
                            label="Composition"
                            :items="itemsComposition"
                            v-model="props.itemtoEdit.composition"
                            variant="outlined"
                            :rules="rules(props.itemtoEdit.composition)"
                        ></v-combobox>
                    </v-col>
    
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="Prix PVC"
                        v-model="props.itemtoEdit.prixPublicTTC"
                        prefix="€"
                        :rules="rules(props.itemtoEdit.prixPublicTTC)"
                    ></v-text-field>
                    </v-col>
    
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-combobox
                            clearable
                            label="SousFamille"
                            :items="itemsSousFamille.sort()"
                            v-model="props.itemtoEdit.sousFamille"
                            variant="outlined"
                            :rules="rules(props.itemtoEdit.sousFamille)"
                        ></v-combobox>
                    </v-col>
    
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-combobox
                            clearable
                            label="Lib couleur"
                            :items="itemscouleur"
                            v-model="props.itemtoEdit.libCouleur"
                            variant="outlined"
                            :rules="rules(props.itemtoEdit.libCouleur)"
                        ></v-combobox>
                    </v-col>
    
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="Prix Achat"
                        v-model="props.itemtoEdit.prixAchatHT"
                        prefix="€"
                        :rules="rules(props.itemtoEdit.prixAchatHT)"
                    ></v-text-field>
                    </v-col>
    
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="QTE"
                        v-model="props.itemtoEdit.qteCommande"
                    ></v-text-field>
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="Poid"
                        v-model="props.itemtoEdit.poid"
                    ></v-text-field>
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="Dimensions"
                        v-model="props.itemtoEdit.dimensions"
                    ></v-text-field>
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="Litrage"
                        v-model="props.itemtoEdit.litrage"
                    ></v-text-field>
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="Fournisseur"
                        v-model="props.itemtoEdit.codeFournisseur"
                    ></v-text-field>
                    
                    </v-col>
                    <v-col
                    cols="11"
                    md="4"
                    sm="6"
                    >
                    <v-text-field
                        label="Remarque"
                        v-model="props.itemtoEdit.remarque"
                    ></v-text-field>
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    sm="6"
                    >
                    
                    <!-- <v-text-field
                        label="Nombre"
                        v-model="props.itemtoEdit.nbre"
                    ></v-text-field> -->
                    
                    </v-col>
                </v-row>
    
                <small class="text-caption text-medium-emphasis">*indicates required field</small>
                </v-card-text>
    
                <v-divider></v-divider>

                <template v-slot:actions>

                    <v-card-actions>
                        <v-btn
                            text="Annuler"
                            @click="editDialog = false"
                            variant="plain"
                            color="red"
                        ></v-btn>
                        <v-btn
                            color="primary"
                            text="modifier"
                            @click="sendArticle();editDialog = false"
                            variant="plain"
                        ></v-btn>
                    </v-card-actions>  
                </template>
    
            </v-card>
        </form>
        </v-dialog>
    </div>              
</template>
  <script setup>
  import { ref,computed, onMounted, } from 'vue';
  import store from './store';
  import axios from 'axios'
    const props=defineProps({
    itemtoEdit:Object
    })
    // console.log(props);
    
    let editDialog=defineModel()
    const modifier=()=>{
            store.commit('editRowArticle',props.itemtoEdit)
        }
    let itemsmarques=computed(()=>{return store.state.marques})
    let itemsThemes=ref(['FRP-Fripe','PTC-Particulier','LUX-Luxe'])
    let itemsComposition=ref(['03-Cuir','06-Synthétique','44-Textile'])

    let itemsSousFamille=ref(['F1A-sac bandoulière',	'F1B-sac porté épaule',	'F1C-sac porté main',	'F1D-sac banane',	'F1E-sac à dos',	'F1F-sac de cérémomie',	'F1G-sac de soirée',	'F2A-porte-monnaie',	'F2B-portefeuille',	'F2C-porte-chéquier',	'F2D-tout-en-un',	'F2E-porte-clefs',	'F2F-porte-cartes',	'F2G-porte-papiers',	'F2H-étui lunettes',	'F2I-étui cigarettes',	'F2K-étui téléphone',	'F2L-trousse',	'F2M-agenda',	'F2N-étui passeport',	'F3A-gants',	'F3B-parapluie',	'F3C-ceinture',	'F3D-foulard',	'F3E-écharpe',	'F3F-chapeau',	'F3G-porte sac',	'F3H-organiseur de sac',	'F3I-coffret bijoux',	'F3J-coffret cadeau',	'F3K-sac provision à roulettes',	'F3L-sac provision',	'F3M-bijoux',	'F3N-bijoux de sac',	'F3O-bandoulière de sac',	'F3P-bonnet',	'F3Q-étole',	'F3R-masque lavable',	'F3S-Coque téléphone',	'F3T-Casquette',	'F3U-Chaine coque téléphone',	'F3V-Bandoulière coque téléphone',	'F3W-Patch',	'F3X-Adaptateur de telephone'])
 
    let rules=(value)=>{
    if (value) return [true]
        return [`Vous devez renseigner le ${[value]}`]
    }

    let itemscouleur=store.state.itemColors
           
    const sendArticle=()=>{
        store.commit('updateCodeFournisseur',props.itemtoEdit.codeFournisseur)
        let data ={article:{
        pole:'SecondLife',
        refFourn:  `${props.itemtoEdit.prixPublicTTC}-${props.itemtoEdit.composition?props.itemtoEdit.composition.split('-')[1].substring(0, 1):''}-${props.itemtoEdit.sousFamille?props.itemtoEdit.sousFamille.split('-')[0].substring(0,2):''}`,
        nomProduit: `${props.itemtoEdit.prixPublicTTC}-${props.itemtoEdit.composition?props.itemtoEdit.composition.split('-')[1].substring(0, 1):''}-${props.itemtoEdit.sousFamille?props.itemtoEdit.sousFamille.split('-')[0].substring(0,2):''}`,
        marque:  props.itemtoEdit.marque,
        theme:  props.itemtoEdit.theme,
        composition:  props.itemtoEdit.composition,
        prixPublicTTC:  props.itemtoEdit.prixPublicTTC,
        sousFamille:  props.itemtoEdit.sousFamille,
        libCouleur:  props.itemtoEdit.libCouleur,
        prixAchatHT:  props.itemtoEdit.prixAchatHT,
        qteCommande:  props.itemtoEdit.qteCommande,
        poidnet:  props.itemtoEdit.poids,
        dimensions:  props.itemtoEdit.dimensions,
        litrage:  props.itemtoEdit.litrage,
        codeFournisseur:  props.itemtoEdit.codeFournisseur,
        remarque:  props.itemtoEdit.remarque,
        totalBrut:  props.itemtoEdit.qteCommande&&props.itemtoEdit.prixAchatHT?props.itemtoEdit.qteCommande*props.itemtoEdit.prixAchatHT:0,
        coefBrut:  props.itemtoEdit.prixAchatHT&&props.itemtoEdit.prixPublicTTC?Number(props.itemtoEdit.prixPublicTTC/props.itemtoEdit.prixAchatHT).toFixed(2):0,
        totalPVpublic:  props.itemtoEdit.qteCommande&&props.itemtoEdit.prixPublicTTC?props.itemtoEdit.qteCommande*props.itemtoEdit.prixPublicTTC:0,
        nbre: 1,
        oldId: props.itemtoEdit.oldId 
        }}
        // console.log(data);
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/getArticle',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        data : data
        }
        if(props.itemtoEdit.oldcouleur!=props.itemtoEdit.libCouleur){
            return axios.request(config)
        .then((response) => { 
            store.commit('editRowArticleFripe',response.data[0])
        })
        .catch((error) => {
        //console.log(error);
        });
        }else{
            store.commit('editRowArticleFripe',props.itemtoEdit)
        }
        
    }
  </script>
  